/**
 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v19.1.4
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var textCellEditor_1 = require("./textCellEditor");

var PopupTextCellEditor =
/** @class */
function (_super) {
  __extends(PopupTextCellEditor, _super);

  function PopupTextCellEditor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PopupTextCellEditor.prototype.isPopup = function () {
    return true;
  };

  return PopupTextCellEditor;
}(textCellEditor_1.TextCellEditor);

exports.PopupTextCellEditor = PopupTextCellEditor;